import { render, staticRenderFns } from "./RecaptchaBranding.vue?vue&type=template&id=8b487fb4&"
import script from "./RecaptchaBranding.vue?vue&type=script&lang=js&"
export * from "./RecaptchaBranding.vue?vue&type=script&lang=js&"
import style0 from "./RecaptchaBranding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports